import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DocumentViewModel from '../ViewModels/DocumentViewModel';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import DocumentUploadBasketRow from './DocumentUploadBasketRow';
import TableBody from '@material-ui/core/TableBody';
import Button from '@material-ui/core/Button';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

interface IDocumentUploadBasketProps {
    documents: DocumentViewModel[];
    removeDocument: (document: DocumentViewModel) => void;
    submitDocuments: () => void;
    uploadAnotherDocument: () => void;
}

interface IDocumentUploadBasketState {
}

export class DocumentUploadBasket extends Component<IDocumentUploadBasketProps & WithStyles<typeof styles>, IDocumentUploadBasketState> {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    public componentDidMount() {
    }

    public render() {
        let items = this.props.documents.map((document, index) => {
            return (
                <DocumentUploadBasketRow document={document} index={index} removeDocument={this.props.removeDocument}/>
            );
        });

        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Secure Document Management
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Table>
                        <TableHead>
                            <TableCell>Name</TableCell>
                            <TableCell>Size</TableCell>
                            <TableCell>File Type</TableCell>
                            <TableCell>Remove</TableCell>
                        </TableHead>
                        <TableBody>
                            {items}
                        </TableBody>
                    </Table>
                </Grid>

                <Grid item xs={12}>
                    <Grid container justify="space-between" alignContent="space-between">
                        <Grid item xs={6}>
                            <Button color="primary" variant="contained" fullWidth onClick={this.props.uploadAnotherDocument}>
                                Upload Another Document
                            </Button>
                        </Grid>
                        <Grid item xs={5}>
                            <Button color="primary" variant="contained" fullWidth onClick={this.props.submitDocuments}>
                                Confirm Upload & Submit
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(DocumentUploadBasket);

